/**
 * SSO Check Script
 * Performs SSO validation for external arrivals and once per internal session
 */

(function() {
  // Skip SSO check in embedded contexts (iframes)
  if (window.self !== window.top || window.frameElement) {
    return;
  }
  
  // Skip SSO check for Shopify admin screenshot contexts
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('preview_theme_id') || 
      navigator.userAgent.includes('Shopify Screenshot') || 
      navigator.userAgent.includes('HeadlessChrome')) {
    return;
  }
  
  // Skip SSO check for bots
  if (window.isbot(navigator.userAgent)) {
    return;
  }
  
  // Get SSO URL from data attribute
  const SSO_URL = document.querySelector('script[data-sso-url]')?.getAttribute('data-sso-url');
  if (!SSO_URL) return;
  
  const SESSION_KEY = 'ssoCheckedRecently';
  const CURRENT_URL = window.location.href;
  const REFERRER = document.referrer;
  const STORE_ORIGIN = window.location.origin;
  
  function isExternalArrival() {
    if (!REFERRER) return false;
    try {
      const referrerUrl = new URL(REFERRER);
      return referrerUrl.origin !== STORE_ORIGIN && 
             !referrerUrl.hostname.includes(window.location.hostname);
    } catch {
      return false;
    }
  }
  
  function performSSOCheck() {
    const redirectUrl = SSO_URL + '?redirectUrl=' + encodeURIComponent(CURRENT_URL);
    window.location.href = redirectUrl;
  }
  
  if (isExternalArrival()) {
    performSSOCheck();
  } else {
    const hasChecked = sessionStorage.getItem(SESSION_KEY);
    if (!hasChecked) {
      sessionStorage.setItem(SESSION_KEY, 'true');
      performSSOCheck();
    }
  }
})();
